<template>
  <div>
    <div class="position-relative dinA4">
      <img :src="require('@/assets/additional-header.png')" class="page__header" />
      <div class="page__container">
        <table class="full-width mt-0">
          <tr class="primary-background">
            <th class="primary-background h1 color-white text-left pl-4 mb-0 pb-1">
              SERVICIOS INCLUIDOS
            </th>
            <th class="primary-background h1 color-white text-left pl-4 mb-0 pb-1"></th>
          </tr>
          <tr>
            <td class="body-2">
              Entrega a domicilio.
            </td>
            <td class="body-2 text-center">
              Incluido
            </td>
          </tr>
          <tr class="mb-0 mt-0 pb-0 pt-0">
            <td class="body-2">
              Cobertura por siniestro: Indemnización conforme a la Ley 15/2009 CTTM art. 57.
            </td>
            <td class="body-2 text-center">
              Incluido
            </td>
          </tr>
          <tr>
            <td class="body-2">
              Incluye hasta 2 intentos de entrega.
            </td>
            <td class="body-2 text-center">
              Incluido
            </td>
          </tr>
          <tr>
            <td class="body-2">
              Notificación E-MAIL por cambio de estado del envío.
            </td>
            <td class="body-2 text-center">
              Incluido
            </td>
          </tr>
          <tr class="table-highlight">
            <td class="body-2">
              <ul>
                <li>Preaviso de Entrega (siempre un día antes).</li>
                <li>
                  Servicio de Entrega Flexible: Cambio de día/dirección/punto Ctt / Agencia en la
                  concertación de la entrega a destinatario.
                </li>
                <li>SMS predicción de franja horaria de entrega a destinatario.</li>
                <li>Email predicción de franja horaria de entrega a destinatario.</li>
              </ul>
            </td>
            <td class="body-2 body-2--bold text-center" :style="{ width: '36px', verticalAlign: 'middle' }">
              Incluido
              <br />
              <br />
              Ctt e24h / e48h
            </td>
          </tr>
          <tr>
            <td class="body-2">
              Gestión proactiva de localización al destinatario
            </td>
            <td class="body-2 text-center">
              Incluido
            </td>
          </tr>
        </table>

        <table class="full-width mt-0">
          <tr class="primary-background">
            <th class="primary-background h1 color-white text-left pl-4 mb-0 pb-1">
              SERVICIOS COMPLEMENTARIOS
            </th>
            <th class="primary-background h1 color-white text-left pl-4 mb-0 pb-1" />
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('SEG_DECLARADO') }}
            </td>
            <td class="body-2 text-center">
              {{ getAdditionalServiceById('SEG_DECLARADO').value }}% (min
              {{ getAdditionalServiceById('SEG_DECLARADO').minValue
              }}<span class="euro-symbol">€</span>)
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('OUTSKIRTS_KM') }}
            </td>
            <td class="body-2 text-center">
              {{ getAdditionalServiceById('KM_EXTRARADIO').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('SATURDAY_DELIVERY') }}
            </td>
            <td class="body-2 text-center">
              {{ getAdditionalServiceById('ENTREGA_SABADO').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('REFUND') }}
            </td>
            <td class="body-2 text-center">
              {{ getAdditionalServiceById('REEMBOLSO').value }}% (min
              {{ getAdditionalServiceById('REEMBOLSO').minValue
              }}<span class="euro-symbol">€</span>)
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('DNI_VALIDATION') }}
            </td>
            <td class="body-2 text-center">
              {{ getAdditionalServiceById('VALIDA_DNI').value }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('SCAN_DELIVERY_NOTE') }}
            </td>
            <td class="body-2 text-center">
              {{ getAdditionalServiceById('ALB_ESCANEADO').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('SMS') }}
            </td>
            <td class="body-2 text-center">
              {{ getAdditionalServiceById('SMS').value }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('EXC_WEIGHT_40') }}
            </td>
            <td class="body-2 text-center">
              {{ getAdditionalServiceById('EXC_PESO_40').value }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('EXC_WEIGHT_70') }}
            </td>
            <td class="body-2 text-center">
              {{ getAdditionalServiceById('EXP_PESO_70').value }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('SUPL_EXC_BULTO_KILO_ADIC') }}
            </td>
            <td class="body-2 text-center">
              {{ getAdditionalServiceById('SUPL_EXC_BULTO_KILO_ADIC').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('EXP_MEASURES_240') }}
            </td>
            <td class="body-2 text-center">
              {{ getAdditionalServiceById('EXP_MEDIDAS_240').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('SUPL_EXC_MEDIDAS_300') }}
            </td>
            <td class="body-2 text-center">
              {{ getAdditionalServiceById('SUPL_EXC_MEDIDAS_300').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('EXP_MEASURES_150') }}
            </td>
            <td class="body-2 text-center">
              {{ getAdditionalServiceById('EXP_MEDIDAS_150').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('EXP_MEASURES_200') }}
            </td>
            <td class="body-2 text-center">
              {{ getAdditionalServiceById('EXP_MEDIDAS_200').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('SUPL_EXC_MEDIDAS_240') }}
            </td>
            <td class="body-2 text-center">
              {{ getAdditionalServiceById('SUPL_EXC_MEDIDAS_240').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('SUPL_IRREGULARES') }}
            </td>
            <td class="body-2 text-center">
              {{ getAdditionalServiceById('SUPL_IRREGULARES').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('SUPL_EXP_MULTIBULTO') }}
            </td>
            <td class="body-2 text-center">
              {{ getAdditionalServiceById('SUPL_EXP_MULTIBULTO').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('REC_FAILED') }}
            </td>
            <td class="body-2 text-center">
              {{ getAdditionalServiceById('REC_FALLIDA').value }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('REC_FAILED_PT') }}
            </td>
            <td class="body-2 text-center">
              {{ getAdditionalServiceById('REC_FALLIDA_PT').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('INTERCITY_SUP') }}
            </td>
            <td class="body-2 text-center">
              {{ getAdditionalServiceById('INTERCITY_SUP').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <tr>
            <td class="body-2">
              {{ $t('INTERCITY_ADIC') }}
            </td>
            <td class="body-2 text-center">
              {{ getAdditionalServiceById('INTERCITY_ADIC').value
              }}<span class="euro-symbol">€</span>
            </td>
          </tr>
          <!-- fin -->
        </table>
      </div>

      <Footer logo :page="previousPages + 1" />
    </div>
  </div>
</template>

<script>
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2022/Footer'

export default {
  name: 'AdditionalServices',
  components: { Footer },
  data() {
    return {
      previousPages: 0,
    }
  },
  methods: {
    getAdditionalServiceById(id) {
      return this.$parent.getAdditionalServiceById(id)
    },
    getAdditionalServiceByDesc(desc) {
      return this.$parent.getAdditionalServiceByDesc(desc)
    },
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('AdditionalServices')
  },
}
</script>
